let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7p6A4"), load("2a8Ft")]).then(() => parcelRequire('gzwHi'));